  
jQuery(document).on('click','.product-picture-count .cst-box',function(){
    total_img_show = jQuery(this).attr('data-show-picture');
    jQuery(this).parents('.product-picture-count').find('.cst-box').removeClass('selected');
    jQuery(this).addClass('selected');

    jQuery('.product-personalizer .cp-sel-Photos').hide();
    jQuery('.product-personalizer .cp-sel-Photos').each(function(i){
        if(total_img_show >= (i+1))
        {
            jQuery(this).show()
        }
    })

  
});
jQuery(document).ready(function() {
  setTimeout(function(){
      jQuery('.number_of_face_sec').insertAfter('.pplr-wrapper.pplr-text.pplr-text');
    var ele_exist = setInterval(function(){
		if(jQuery('.pplr-wrapper.pplr-image--1.cp-sel-Photos').length >= 1)
        {
    		jQuery('.number_of_face_sec').insertBefore(jQuery('.pplr-wrapper.pplr-image--1.cp-sel-Photos'));      
			clearInterval(ele_exist);
        }
	});
    
  }, 100);

// Additional code to dynamically set the 'required' attribute based on the selected number of images
jQuery(document).on('click', '.product-picture-count .cst-box', function() {
    let total_img_show = parseInt(jQuery(this).attr('data-show-picture'));

    // Set required attribute based on total_img_show
    jQuery('.product-personalizer .cp-sel-Photos input[type="file"]').each(function(index) {
        if (index < total_img_show) {
            jQuery(this).attr('required', true);
        } else {
            jQuery(this).removeAttr('required');
        }
    });
});


  
/* Home Page Riview Sec */
//   setTimeout(function(){setInterval(function(){if(typeof pplr_hide !== undefined){pplr_hide(3);}});},5000);
  
  function isMobileDevice() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
};
  
  
  if(isMobileDevice())
  {
  jQuery('label[for="SingleOptionSelector-"]').addClass('close');
  jQuery('#SingleOptionSelector-').addClass('cst-hide');
  
  jQuery(document).on('click','label[for="SingleOptionSelector-"]',function()
	{
    if(jQuery('div#SingleOptionSelector-').hasClass("cst-hide"))
    {
        jQuery('div#SingleOptionSelector-').addClass("cst-show");
        jQuery('div#SingleOptionSelector-').removeClass("cst-hide");
jQuery('label[for="SingleOptionSelector-"]').addClass('open');
        jQuery('label[for="SingleOptionSelector-"]').removeClass('close');
        
    }
    else
    {
        jQuery('div#SingleOptionSelector-').addClass("cst-hide");
        jQuery('div#SingleOptionSelector-').removeClass("cst-show");
jQuery('label[for="SingleOptionSelector-"]').addClass('close');
        jQuery('label[for="SingleOptionSelector-"]').removeClass('open');      	
      
    }
});
}

});


 $( document ).ready(function() {
      $('.clint-riview').slick({
        infinite: true,
        slidesToShow: 3, // Shows a three slides at a time
        slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
        arrows: true, // Adds arrows to sides of slider
        dots: false,
         responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          }
        ],// Adds the dots on the bottom
      });
  });

/* Product Detaile Page */
// $(document).ready(function(){
  
//     $(".view_size_chart").click(function(){
//         $(".view_cart_sec").toggleClass("view_cart_popup");		
//     });
// });
// $(document).ready(function(){
//     $(".view_cart_popup_inner_close").click(function(){
//         $(".view_cart_sec").toggleClass("view_cart_popup");		
//     });
// });
// $(document).ready(function(){
//   $(".view_size_chart").click(function(){
// //     alert("test");
//     $("body").addClass("view_charg_bg");
    
//   });
//   $(".view_cart_popup_inner_close").click(function(){
//     $("body").removeClass("view_charg_bg");
//   });
// });
// /* View  Image Chart */
// $(document).ready(function(){
//     $(".view_image_chart").click(function(){
//         $(".image_chart_sec").toggleClass("number_face_sec");		
//     });
// });
// $(document).ready(function(){
//     $(".view_image_popup_inner_close").click(function(){
//         $(".image_chart_sec").toggleClass("number_face_sec");		
//     });
  
//   $(document).on('click', function(e) {
//   // Elements you don't want to remove the class name with...
//   if($(e.target).is('.view_cart_sec')) {
//     // If anything outside of those is clicked, remove the active class to hide the popup.
// //     $('body div').removeClass('view_cart_sec');
//     $(".view_cart_sec").toggleClass("view_cart_popup")
//   }
   
// 	})
 
// });
$(document).ready(function(){
  $('.view_image_chart').on('click', function(e) {
    e.preventDefault();
    $('.img_chart_sec').toggleClass('is-visible');
  });

  
/* Product Detaile Chart scroll */
  $("span.collor_size_see").click(function(){
    $(".collor_size_innner_table").slideToggle("collor_size_innner_table_opne");
    $("body").toggleClass("collor_size_main_sec");
  });

});


$(document).ready(function () {
    $(".open-size-chart-popup").on("click", function (e) {
      e.preventDefault();
      $(".size-chart-collar").toggleClass("is-visible");
    });
  });


$(document).ready(function () {
    $(".size_chart_inner_sec .view_img_popup_inner_close").on("click", function (e) {
      e.preventDefault();
      $(".size-chart-collar").removeClass("is-visible");
    });
  });
